module.exports = __webpack_public_path__ + "img/split-04.1dba12e3.jpg";